"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* tslint:disable no-conditional-assignment */
function pureUA() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var platform = arguments.length > 1 ? arguments[1] : undefined;
  var maxTouchPoints = arguments.length > 2 ? arguments[2] : undefined;
  userAgent = userAgent.toLowerCase();
  var os = {};
  var browser = {};
  var match;

  if (match = userAgent.match(/android;?[\s/]+([\d.]+)?/)) {
    os.android = true;

    if (match[1]) {
      os.version = match[1];
    }
  } else {
    if (match = userAgent.match(/ipod(?:.*os\s([\d_]+))?/)) {
      os.ipod = true;

      if (match[1]) {
        os.version = match[1].split('_').join('.');
      }
    } else {
      if (match = userAgent.match(/ipad.*os\s([\d_]+)/)) {
        os.ipad = true;
        os.version = match[1].split('_').join('.');
      } else if (platform === 'MacIntel' && maxTouchPoints > 1 && (match = userAgent.match(/version\/([\d.]+)/))) {
        os.ipad = true;
        os.version = match[1];
      } else if (match = userAgent.match(/iphone\sos\s([\d_]+)/)) {
        os.iphone = true;
        os.version = match[1].split('_').join('.');
      }
    }

    os.ios = os.ipad || os.iphone || os.ipod;
  }

  if (match = userAgent.match(/micromessenger[\s/]+([\d.]+)/)) {
    browser.weixin = true;
    browser.version = match[1];
  } else if (match = userAgent.match(/\sqq[\s/]+([\d.]+)/)) {
    browser.qq = true;
    browser.version = match[1];
  } else if (match = userAgent.match(/weibo[\s_]+([\d.]+)/)) {
    browser.weibo = true;
    browser.version = match[1];
  }

  return {
    browser: browser,
    os: os
  };
}

pureUA["default"] = pureUA;
var _default = pureUA;
exports["default"] = _default;
module.exports = exports["default"];